import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import constants from "../../constants";
import http from "../http";
import linkedAccounts from "./linkedAccounts";
import academicYearServices from "../academicYear";
import deleteRefreshToken from "./deleteRefreshToken";
import passwordReset from "./passwordReset";
import emailVerification from "./emailVerification";
var USERS_ENDPOINT = "".concat(constants.API_URL, "/users");
var USERS_ENDPOINT_V1 = "".concat(constants.API_URL_V1, "/users");
var ME_ENDPOINT = "".concat(constants.API_URL, "/users/me");
var NOTIFICATIONS_LIST_ENDPOINT = "".concat(constants.API_URL, "/users/me/notifications");

function registerPushNotificationToken(_x) {
  return _registerPushNotificationToken.apply(this, arguments);
}

function _registerPushNotificationToken() {
  _registerPushNotificationToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(_ref) {
    var token, service, response;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            token = _ref.token, service = _ref.service;
            _context20.next = 3;
            return http.post("".concat(ME_ENDPOINT, "/push-notification-tokens"), {
              token: token,
              service: service
            });

          case 3:
            response = _context20.sent;
            return _context20.abrupt("return", response);

          case 5:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _registerPushNotificationToken.apply(this, arguments);
}

function unregisterPushNotificationToken(_x2) {
  return _unregisterPushNotificationToken.apply(this, arguments);
}

function _unregisterPushNotificationToken() {
  _unregisterPushNotificationToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(_ref2) {
    var token, service, response;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            token = _ref2.token, service = _ref2.service;
            _context21.next = 3;
            return http.post("".concat(ME_ENDPOINT, "/delete-push-notification-token"), {
              token: token,
              service: service
            });

          case 3:
            response = _context21.sent;
            return _context21.abrupt("return", response);

          case 5:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
  return _unregisterPushNotificationToken.apply(this, arguments);
}

function getUserCourseGrades(_x3) {
  return _getUserCourseGrades.apply(this, arguments);
}

function _getUserCourseGrades() {
  _getUserCourseGrades = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(_ref3) {
    var userId, courseId, response;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            userId = _ref3.userId, courseId = _ref3.courseId;
            _context22.next = 3;
            return http.get("".concat(constants.API_URL, "/users/").concat(userId, "/courses/").concat(courseId, "/gradebook"));

          case 3:
            response = _context22.sent;
            return _context22.abrupt("return", response);

          case 5:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
  return _getUserCourseGrades.apply(this, arguments);
}

function getUserData() {
  return _getUserData.apply(this, arguments);
}

function _getUserData() {
  _getUserData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
    var response;
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            _context23.next = 2;
            return http.get(ME_ENDPOINT);

          case 2:
            response = _context23.sent;
            return _context23.abrupt("return", response);

          case 4:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));
  return _getUserData.apply(this, arguments);
}

function getUserGradeableItems(_x4) {
  return _getUserGradeableItems.apply(this, arguments);
}

function _getUserGradeableItems() {
  _getUserGradeableItems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(_ref4) {
    var userId, params, response;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            userId = _ref4.userId, params = _ref4.params;
            _context24.next = 3;
            return http.get("".concat(constants.API_URL, "/users/").concat(userId, "/gradable-items"), {
              params: params
            });

          case 3:
            response = _context24.sent;
            return _context24.abrupt("return", response);

          case 5:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));
  return _getUserGradeableItems.apply(this, arguments);
}

function getUserMaterials(_x5) {
  return _getUserMaterials.apply(this, arguments);
}

function _getUserMaterials() {
  _getUserMaterials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(_ref5) {
    var userId, params, response;
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            userId = _ref5.userId, params = _ref5.params;
            _context25.next = 3;
            return http.get("".concat(USERS_ENDPOINT_V1, "/").concat(userId, "/materials"), {
              params: params
            });

          case 3:
            response = _context25.sent;
            return _context25.abrupt("return", response);

          case 5:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25);
  }));
  return _getUserMaterials.apply(this, arguments);
}

function getUserAnnouncements(_x6) {
  return _getUserAnnouncements.apply(this, arguments);
}

function _getUserAnnouncements() {
  _getUserAnnouncements = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(_ref6) {
    var userId, params, _yield$http$get, data;

    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            userId = _ref6.userId, params = _ref6.params;
            _context26.next = 3;
            return http.get("".concat(constants.API_URL_V1, "/users/").concat(userId, "/announcements"), {
              params: params
            });

          case 3:
            _yield$http$get = _context26.sent;
            data = _yield$http$get.data;
            return _context26.abrupt("return", data);

          case 6:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26);
  }));
  return _getUserAnnouncements.apply(this, arguments);
}

function changeUserRole(_x7) {
  return _changeUserRole.apply(this, arguments);
}

function _changeUserRole() {
  _changeUserRole = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(_ref7) {
    var userId, params, response;
    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            userId = _ref7.userId, params = _ref7.params;
            _context27.next = 3;
            return http.post("".concat(USERS_ENDPOINT, "/").concat(userId, "/change-base-role"), _objectSpread({}, params));

          case 3:
            response = _context27.sent;
            return _context27.abrupt("return", response);

          case 5:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27);
  }));
  return _changeUserRole.apply(this, arguments);
}

function deactivateUser(_x8) {
  return _deactivateUser.apply(this, arguments);
}

function _deactivateUser() {
  _deactivateUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(_ref8) {
    var userId, response;
    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            userId = _ref8.userId;
            _context28.next = 3;
            return http.post("".concat(USERS_ENDPOINT, "/").concat(userId, "/deactivate"));

          case 3:
            response = _context28.sent;
            return _context28.abrupt("return", response);

          case 5:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28);
  }));
  return _deactivateUser.apply(this, arguments);
}

function activateUser(_x9) {
  return _activateUser.apply(this, arguments);
}

function _activateUser() {
  _activateUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(_ref9) {
    var userId, response;
    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            userId = _ref9.userId;
            _context29.next = 3;
            return http.post("".concat(USERS_ENDPOINT, "/").concat(userId, "/activate"));

          case 3:
            response = _context29.sent;
            return _context29.abrupt("return", response);

          case 5:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29);
  }));
  return _activateUser.apply(this, arguments);
}

function updateUser(_x10) {
  return _updateUser.apply(this, arguments);
}

function _updateUser() {
  _updateUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(_ref10) {
    var userId, user, response;
    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            userId = _ref10.userId, user = _ref10.user;
            _context30.next = 3;
            return http.patch("".concat(USERS_ENDPOINT, "/").concat(userId), user);

          case 3:
            response = _context30.sent;
            return _context30.abrupt("return", response);

          case 5:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee30);
  }));
  return _updateUser.apply(this, arguments);
}

function updateMe(_x11) {
  return _updateMe.apply(this, arguments);
}

function _updateMe() {
  _updateMe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(data) {
    var response;
    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            _context31.next = 2;
            return http.patch(ME_ENDPOINT, data);

          case 2:
            response = _context31.sent;
            return _context31.abrupt("return", response);

          case 4:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee31);
  }));
  return _updateMe.apply(this, arguments);
}

function getStudentSemesters(_x12) {
  return _getStudentSemesters.apply(this, arguments);
}

function _getStudentSemesters() {
  _getStudentSemesters = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(_ref11) {
    var studentId, response;
    return _regeneratorRuntime.wrap(function _callee32$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            studentId = _ref11.studentId;
            _context32.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/students/").concat(studentId, "/semesters"));

          case 3:
            response = _context32.sent;
            return _context32.abrupt("return", response);

          case 5:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee32);
  }));
  return _getStudentSemesters.apply(this, arguments);
}

function getTeacherSemesters(_x13) {
  return _getTeacherSemesters.apply(this, arguments);
}

function _getTeacherSemesters() {
  _getTeacherSemesters = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(_ref12) {
    var teacherId, response;
    return _regeneratorRuntime.wrap(function _callee33$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            teacherId = _ref12.teacherId;
            _context33.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/teachers/").concat(teacherId, "/semesters"));

          case 3:
            response = _context33.sent;
            return _context33.abrupt("return", response);

          case 5:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee33);
  }));
  return _getTeacherSemesters.apply(this, arguments);
}

function getUserCourses(_x14) {
  return _getUserCourses.apply(this, arguments);
}

function _getUserCourses() {
  _getUserCourses = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(params) {
    var _yield$academicYearSe, data;

    return _regeneratorRuntime.wrap(function _callee34$(_context34) {
      while (1) {
        switch (_context34.prev = _context34.next) {
          case 0:
            _context34.next = 2;
            return academicYearServices.getAcademicYearCourses({
              academicYearId: params.academicYearId,
              params: {
                limit: -1
              }
            });

          case 2:
            _yield$academicYearSe = _context34.sent;
            data = _yield$academicYearSe.data;
            return _context34.abrupt("return", data);

          case 5:
          case "end":
            return _context34.stop();
        }
      }
    }, _callee34);
  }));
  return _getUserCourses.apply(this, arguments);
}

function getTeacherCourseTemplates(_x15) {
  return _getTeacherCourseTemplates.apply(this, arguments);
}

function _getTeacherCourseTemplates() {
  _getTeacherCourseTemplates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(_ref13) {
    var teacherId, params, response;
    return _regeneratorRuntime.wrap(function _callee35$(_context35) {
      while (1) {
        switch (_context35.prev = _context35.next) {
          case 0:
            teacherId = _ref13.teacherId, params = _ref13.params;
            _context35.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/teachers/").concat(teacherId, "/courses/course-templates"), {
              params: params
            });

          case 3:
            response = _context35.sent;
            return _context35.abrupt("return", response);

          case 5:
          case "end":
            return _context35.stop();
        }
      }
    }, _callee35);
  }));
  return _getTeacherCourseTemplates.apply(this, arguments);
}

function getTeacherQuestions(_x16) {
  return _getTeacherQuestions.apply(this, arguments);
}

function _getTeacherQuestions() {
  _getTeacherQuestions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(_ref14) {
    var teacherId, params, response;
    return _regeneratorRuntime.wrap(function _callee36$(_context36) {
      while (1) {
        switch (_context36.prev = _context36.next) {
          case 0:
            teacherId = _ref14.teacherId, params = _ref14.params;
            _context36.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/teachers/").concat(teacherId, "/questions"), {
              params: params
            });

          case 3:
            response = _context36.sent;
            return _context36.abrupt("return", response);

          case 5:
          case "end":
            return _context36.stop();
        }
      }
    }, _callee36);
  }));
  return _getTeacherQuestions.apply(this, arguments);
}

function updateSubjects(_x17) {
  return _updateSubjects.apply(this, arguments);
}

function _updateSubjects() {
  _updateSubjects = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(_ref15) {
    var teacherId, subjects, response;
    return _regeneratorRuntime.wrap(function _callee37$(_context37) {
      while (1) {
        switch (_context37.prev = _context37.next) {
          case 0:
            teacherId = _ref15.teacherId, subjects = _ref15.subjects;
            _context37.next = 3;
            return http.patch("".concat(USERS_ENDPOINT, "/teachers/").concat(teacherId), {
              subjectIds: subjects
            });

          case 3:
            response = _context37.sent;
            return _context37.abrupt("return", response);

          case 5:
          case "end":
            return _context37.stop();
        }
      }
    }, _callee37);
  }));
  return _updateSubjects.apply(this, arguments);
}

function getHodCourseTemplates(_x18) {
  return _getHodCourseTemplates.apply(this, arguments);
}

function _getHodCourseTemplates() {
  _getHodCourseTemplates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(_ref16) {
    var hodId, params, response;
    return _regeneratorRuntime.wrap(function _callee38$(_context38) {
      while (1) {
        switch (_context38.prev = _context38.next) {
          case 0:
            hodId = _ref16.hodId, params = _ref16.params;
            _context38.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/hods/").concat(hodId, "/course-templates"), {
              params: params
            });

          case 3:
            response = _context38.sent;
            return _context38.abrupt("return", response);

          case 5:
          case "end":
            return _context38.stop();
        }
      }
    }, _callee38);
  }));
  return _getHodCourseTemplates.apply(this, arguments);
}

function updateCourseTemplates(_x19) {
  return _updateCourseTemplates.apply(this, arguments);
}

function _updateCourseTemplates() {
  _updateCourseTemplates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(_ref17) {
    var hodId, courseTemplates, response;
    return _regeneratorRuntime.wrap(function _callee39$(_context39) {
      while (1) {
        switch (_context39.prev = _context39.next) {
          case 0:
            hodId = _ref17.hodId, courseTemplates = _ref17.courseTemplates;
            _context39.next = 3;
            return http.patch("".concat(USERS_ENDPOINT, "/hods/").concat(hodId), {
              courseTemplateIds: courseTemplates
            });

          case 3:
            response = _context39.sent;
            return _context39.abrupt("return", response);

          case 5:
          case "end":
            return _context39.stop();
        }
      }
    }, _callee39);
  }));
  return _updateCourseTemplates.apply(this, arguments);
}

function getHodQuestions(_x20) {
  return _getHodQuestions.apply(this, arguments);
}

function _getHodQuestions() {
  _getHodQuestions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(_ref18) {
    var hodId, params, response;
    return _regeneratorRuntime.wrap(function _callee40$(_context40) {
      while (1) {
        switch (_context40.prev = _context40.next) {
          case 0:
            hodId = _ref18.hodId, params = _ref18.params;
            _context40.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/hods/").concat(hodId, "/questions"), {
              params: params
            });

          case 3:
            response = _context40.sent;
            return _context40.abrupt("return", response);

          case 5:
          case "end":
            return _context40.stop();
        }
      }
    }, _callee40);
  }));
  return _getHodQuestions.apply(this, arguments);
}

function getPrincipalCourseTemplates(_x21) {
  return _getPrincipalCourseTemplates.apply(this, arguments);
}

function _getPrincipalCourseTemplates() {
  _getPrincipalCourseTemplates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(_ref19) {
    var principalId, params, response;
    return _regeneratorRuntime.wrap(function _callee41$(_context41) {
      while (1) {
        switch (_context41.prev = _context41.next) {
          case 0:
            principalId = _ref19.principalId, params = _ref19.params;
            _context41.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/principals/").concat(principalId, "/course-templates"), {
              params: params
            });

          case 3:
            response = _context41.sent;
            return _context41.abrupt("return", response);

          case 5:
          case "end":
            return _context41.stop();
        }
      }
    }, _callee41);
  }));
  return _getPrincipalCourseTemplates.apply(this, arguments);
}

function getPrincipalQuestions(_x22) {
  return _getPrincipalQuestions.apply(this, arguments);
}

function _getPrincipalQuestions() {
  _getPrincipalQuestions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(_ref20) {
    var principalId, params, response;
    return _regeneratorRuntime.wrap(function _callee42$(_context42) {
      while (1) {
        switch (_context42.prev = _context42.next) {
          case 0:
            principalId = _ref20.principalId, params = _ref20.params;
            _context42.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/principals/").concat(principalId, "/questions"), {
              params: params
            });

          case 3:
            response = _context42.sent;
            return _context42.abrupt("return", response);

          case 5:
          case "end":
            return _context42.stop();
        }
      }
    }, _callee42);
  }));
  return _getPrincipalQuestions.apply(this, arguments);
}

function getPrincipalClasses(_x23) {
  return _getPrincipalClasses.apply(this, arguments);
}

function _getPrincipalClasses() {
  _getPrincipalClasses = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(_ref21) {
    var principalId, academicYearId, response;
    return _regeneratorRuntime.wrap(function _callee43$(_context43) {
      while (1) {
        switch (_context43.prev = _context43.next) {
          case 0:
            principalId = _ref21.principalId, academicYearId = _ref21.academicYearId;
            _context43.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/principals/").concat(principalId, "/classes"), {
              params: {
                academicYearId: academicYearId
              }
            });

          case 3:
            response = _context43.sent;
            return _context43.abrupt("return", response);

          case 5:
          case "end":
            return _context43.stop();
        }
      }
    }, _callee43);
  }));
  return _getPrincipalClasses.apply(this, arguments);
}

function updatePrincipal(_x24) {
  return _updatePrincipal.apply(this, arguments);
}

function _updatePrincipal() {
  _updatePrincipal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(_ref22) {
    var principalId, params, response;
    return _regeneratorRuntime.wrap(function _callee44$(_context44) {
      while (1) {
        switch (_context44.prev = _context44.next) {
          case 0:
            principalId = _ref22.principalId, params = _ref22.params;
            _context44.next = 3;
            return http.patch("".concat(USERS_ENDPOINT, "/principals/").concat(principalId), _objectSpread({}, params));

          case 3:
            response = _context44.sent;
            return _context44.abrupt("return", response);

          case 5:
          case "end":
            return _context44.stop();
        }
      }
    }, _callee44);
  }));
  return _updatePrincipal.apply(this, arguments);
}

function updateParent(_x25) {
  return _updateParent.apply(this, arguments);
}

function _updateParent() {
  _updateParent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(_ref23) {
    var parentId, childrenIds, response;
    return _regeneratorRuntime.wrap(function _callee45$(_context45) {
      while (1) {
        switch (_context45.prev = _context45.next) {
          case 0:
            parentId = _ref23.parentId, childrenIds = _ref23.childrenIds;
            _context45.next = 3;
            return http.patch("".concat(USERS_ENDPOINT, "/parents/").concat(parentId), {
              childrenIds: childrenIds
            });

          case 3:
            response = _context45.sent;
            return _context45.abrupt("return", response);

          case 5:
          case "end":
            return _context45.stop();
        }
      }
    }, _callee45);
  }));
  return _updateParent.apply(this, arguments);
}

function getHodClasses(_x26) {
  return _getHodClasses.apply(this, arguments);
}

function _getHodClasses() {
  _getHodClasses = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(_ref24) {
    var hodId, academicYearId, response;
    return _regeneratorRuntime.wrap(function _callee46$(_context46) {
      while (1) {
        switch (_context46.prev = _context46.next) {
          case 0:
            hodId = _ref24.hodId, academicYearId = _ref24.academicYearId;
            _context46.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/hods/").concat(hodId, "/classes"), {
              params: {
                academicYearId: academicYearId
              }
            });

          case 3:
            response = _context46.sent;
            return _context46.abrupt("return", response);

          case 5:
          case "end":
            return _context46.stop();
        }
      }
    }, _callee46);
  }));
  return _getHodClasses.apply(this, arguments);
}

function getTeacherClasses(_x27) {
  return _getTeacherClasses.apply(this, arguments);
}

function _getTeacherClasses() {
  _getTeacherClasses = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(_ref25) {
    var teacherId, academicYearId, response;
    return _regeneratorRuntime.wrap(function _callee47$(_context47) {
      while (1) {
        switch (_context47.prev = _context47.next) {
          case 0:
            teacherId = _ref25.teacherId, academicYearId = _ref25.academicYearId;
            _context47.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/teachers/").concat(teacherId, "/classes"), {
              params: {
                academicYearId: academicYearId
              }
            });

          case 3:
            response = _context47.sent;
            return _context47.abrupt("return", response);

          case 5:
          case "end":
            return _context47.stop();
        }
      }
    }, _callee47);
  }));
  return _getTeacherClasses.apply(this, arguments);
}

function getUserActiveSubmission(_x28) {
  return _getUserActiveSubmission.apply(this, arguments);
}

function _getUserActiveSubmission() {
  _getUserActiveSubmission = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(_ref26) {
    var studentId, assessmentId, response;
    return _regeneratorRuntime.wrap(function _callee48$(_context48) {
      while (1) {
        switch (_context48.prev = _context48.next) {
          case 0:
            studentId = _ref26.studentId, assessmentId = _ref26.assessmentId;
            _context48.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/students/").concat(studentId, "/assessments/").concat(assessmentId, "/submissions/active"));

          case 3:
            response = _context48.sent;
            return _context48.abrupt("return", response);

          case 5:
          case "end":
            return _context48.stop();
        }
      }
    }, _callee48);
  }));
  return _getUserActiveSubmission.apply(this, arguments);
}

function getStudentAssessments(_x29) {
  return _getStudentAssessments.apply(this, arguments);
} // Notification


function _getStudentAssessments() {
  _getStudentAssessments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(_ref27) {
    var studentId, params, response;
    return _regeneratorRuntime.wrap(function _callee49$(_context49) {
      while (1) {
        switch (_context49.prev = _context49.next) {
          case 0:
            studentId = _ref27.studentId, params = _ref27.params;
            _context49.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/students/").concat(studentId, "/assessments"), {
              params: params
            });

          case 3:
            response = _context49.sent;
            return _context49.abrupt("return", response);

          case 5:
          case "end":
            return _context49.stop();
        }
      }
    }, _callee49);
  }));
  return _getStudentAssessments.apply(this, arguments);
}

function listNotifications() {
  return _listNotifications.apply(this, arguments);
}

function _listNotifications() {
  _listNotifications = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50() {
    var response;
    return _regeneratorRuntime.wrap(function _callee50$(_context50) {
      while (1) {
        switch (_context50.prev = _context50.next) {
          case 0:
            _context50.next = 2;
            return http.get(NOTIFICATIONS_LIST_ENDPOINT);

          case 2:
            response = _context50.sent;
            return _context50.abrupt("return", response);

          case 4:
          case "end":
            return _context50.stop();
        }
      }
    }, _callee50);
  }));
  return _listNotifications.apply(this, arguments);
}

function markAllNotificationsAsSeen() {
  return _markAllNotificationsAsSeen.apply(this, arguments);
}

function _markAllNotificationsAsSeen() {
  _markAllNotificationsAsSeen = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51() {
    var response;
    return _regeneratorRuntime.wrap(function _callee51$(_context51) {
      while (1) {
        switch (_context51.prev = _context51.next) {
          case 0:
            _context51.next = 2;
            return http.post("".concat(NOTIFICATIONS_LIST_ENDPOINT, "/see-all"));

          case 2:
            response = _context51.sent;
            return _context51.abrupt("return", response);

          case 4:
          case "end":
            return _context51.stop();
        }
      }
    }, _callee51);
  }));
  return _markAllNotificationsAsSeen.apply(this, arguments);
}

function markAllNotificationsAsRead(_x30) {
  return _markAllNotificationsAsRead.apply(this, arguments);
}

function _markAllNotificationsAsRead() {
  _markAllNotificationsAsRead = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(_ref28) {
    var _ref28$module, module, param, response;

    return _regeneratorRuntime.wrap(function _callee52$(_context52) {
      while (1) {
        switch (_context52.prev = _context52.next) {
          case 0:
            _ref28$module = _ref28.module, module = _ref28$module === void 0 ? undefined : _ref28$module;
            param = module ? "?module=".concat(module) : "";
            _context52.next = 4;
            return http.post("".concat(NOTIFICATIONS_LIST_ENDPOINT, "/read-all").concat(param));

          case 4:
            response = _context52.sent;
            return _context52.abrupt("return", response);

          case 6:
          case "end":
            return _context52.stop();
        }
      }
    }, _callee52);
  }));
  return _markAllNotificationsAsRead.apply(this, arguments);
}

function getUnreadNotificationsCount(_x31) {
  return _getUnreadNotificationsCount.apply(this, arguments);
}

function _getUnreadNotificationsCount() {
  _getUnreadNotificationsCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(_ref29) {
    var _ref29$module, module, param, response;

    return _regeneratorRuntime.wrap(function _callee53$(_context53) {
      while (1) {
        switch (_context53.prev = _context53.next) {
          case 0:
            _ref29$module = _ref29.module, module = _ref29$module === void 0 ? undefined : _ref29$module;
            param = module ? "?module=".concat(module) : "";
            _context53.next = 4;
            return http.get("".concat(NOTIFICATIONS_LIST_ENDPOINT, "/unread-count").concat(param));

          case 4:
            response = _context53.sent;
            return _context53.abrupt("return", response);

          case 6:
          case "end":
            return _context53.stop();
        }
      }
    }, _callee53);
  }));
  return _getUnreadNotificationsCount.apply(this, arguments);
}

function getUnseenNotificationsCount() {
  return _getUnseenNotificationsCount.apply(this, arguments);
}

function _getUnseenNotificationsCount() {
  _getUnseenNotificationsCount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54() {
    var response;
    return _regeneratorRuntime.wrap(function _callee54$(_context54) {
      while (1) {
        switch (_context54.prev = _context54.next) {
          case 0:
            _context54.next = 2;
            return http.get("".concat(NOTIFICATIONS_LIST_ENDPOINT, "/unseen-count"));

          case 2:
            response = _context54.sent;
            return _context54.abrupt("return", response);

          case 4:
          case "end":
            return _context54.stop();
        }
      }
    }, _callee54);
  }));
  return _getUnseenNotificationsCount.apply(this, arguments);
}

function deactivateBulkUsers(_x32) {
  return _deactivateBulkUsers.apply(this, arguments);
}

function _deactivateBulkUsers() {
  _deactivateBulkUsers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(_ref30) {
    var userIds, response;
    return _regeneratorRuntime.wrap(function _callee55$(_context55) {
      while (1) {
        switch (_context55.prev = _context55.next) {
          case 0:
            userIds = _ref30.userIds;
            _context55.next = 3;
            return http.post("".concat(USERS_ENDPOINT, "/deactivate-bulk"), {
              userIds: userIds
            });

          case 3:
            response = _context55.sent;
            return _context55.abrupt("return", response);

          case 5:
          case "end":
            return _context55.stop();
        }
      }
    }, _callee55);
  }));
  return _deactivateBulkUsers.apply(this, arguments);
}

function activateBulkUsers(_x33) {
  return _activateBulkUsers.apply(this, arguments);
}

function _activateBulkUsers() {
  _activateBulkUsers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(_ref31) {
    var userIds, response;
    return _regeneratorRuntime.wrap(function _callee56$(_context56) {
      while (1) {
        switch (_context56.prev = _context56.next) {
          case 0:
            userIds = _ref31.userIds;
            _context56.next = 3;
            return http.post("".concat(USERS_ENDPOINT, "/activate-bulk"), {
              userIds: userIds
            });

          case 3:
            response = _context56.sent;
            return _context56.abrupt("return", response);

          case 5:
          case "end":
            return _context56.stop();
        }
      }
    }, _callee56);
  }));
  return _activateBulkUsers.apply(this, arguments);
}

function updateStudentPerformanceComment(_x34) {
  return _updateStudentPerformanceComment.apply(this, arguments);
} // Get assessments for a student for the channelBook


function _updateStudentPerformanceComment() {
  _updateStudentPerformanceComment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(_ref32) {
    var studentId, performanceComment, response;
    return _regeneratorRuntime.wrap(function _callee57$(_context57) {
      while (1) {
        switch (_context57.prev = _context57.next) {
          case 0:
            studentId = _ref32.studentId, performanceComment = _ref32.performanceComment;
            _context57.next = 3;
            return http.patch("".concat(USERS_ENDPOINT, "/students/").concat(studentId, "/performance-comment"), {
              performanceComment: performanceComment
            });

          case 3:
            response = _context57.sent;
            return _context57.abrupt("return", response);

          case 5:
          case "end":
            return _context57.stop();
        }
      }
    }, _callee57);
  }));
  return _updateStudentPerformanceComment.apply(this, arguments);
}

function getStudentAssessmentsV1(_x35) {
  return _getStudentAssessmentsV.apply(this, arguments);
} // Get homework for a student with courses' titles


function _getStudentAssessmentsV() {
  _getStudentAssessmentsV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(_ref33) {
    var studentId, params, response;
    return _regeneratorRuntime.wrap(function _callee58$(_context58) {
      while (1) {
        switch (_context58.prev = _context58.next) {
          case 0:
            studentId = _ref33.studentId, params = _ref33.params;
            _context58.next = 3;
            return http.get("".concat(constants.API_URL_V1, "/users/students/").concat(studentId, "/assessments"), {
              params: params
            });

          case 3:
            response = _context58.sent;
            return _context58.abrupt("return", response);

          case 5:
          case "end":
            return _context58.stop();
        }
      }
    }, _callee58);
  }));
  return _getStudentAssessmentsV.apply(this, arguments);
}

function getStudentHomework(_x36) {
  return _getStudentHomework.apply(this, arguments);
} // Get  classworks for a student for the channelBook


function _getStudentHomework() {
  _getStudentHomework = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(_ref34) {
    var studentId, params, response;
    return _regeneratorRuntime.wrap(function _callee59$(_context59) {
      while (1) {
        switch (_context59.prev = _context59.next) {
          case 0:
            studentId = _ref34.studentId, params = _ref34.params;
            _context59.next = 3;
            return http.get("".concat(constants.API_URL_V1, "/users/students/").concat(studentId, "/homeworks"), {
              params: params
            });

          case 3:
            response = _context59.sent;
            return _context59.abrupt("return", response);

          case 5:
          case "end":
            return _context59.stop();
        }
      }
    }, _callee59);
  }));
  return _getStudentHomework.apply(this, arguments);
}

function getStudentClasswork(_x37) {
  return _getStudentClasswork.apply(this, arguments);
}

function _getStudentClasswork() {
  _getStudentClasswork = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(_ref35) {
    var studentId, params, response;
    return _regeneratorRuntime.wrap(function _callee60$(_context60) {
      while (1) {
        switch (_context60.prev = _context60.next) {
          case 0:
            studentId = _ref35.studentId, params = _ref35.params;
            _context60.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/students/").concat(studentId, "/classwork"), {
              params: params
            });

          case 3:
            response = _context60.sent;
            return _context60.abrupt("return", response);

          case 5:
          case "end":
            return _context60.stop();
        }
      }
    }, _callee60);
  }));
  return _getStudentClasswork.apply(this, arguments);
}

function viewAsUser(_x38) {
  return _viewAsUser.apply(this, arguments);
}

function _viewAsUser() {
  _viewAsUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(_ref36) {
    var userId, response;
    return _regeneratorRuntime.wrap(function _callee61$(_context61) {
      while (1) {
        switch (_context61.prev = _context61.next) {
          case 0:
            userId = _ref36.userId;
            _context61.next = 3;
            return http.post("".concat(USERS_ENDPOINT, "/").concat(userId, "/impersonate"));

          case 3:
            response = _context61.sent;
            return _context61.abrupt("return", response);

          case 5:
          case "end":
            return _context61.stop();
        }
      }
    }, _callee61);
  }));
  return _viewAsUser.apply(this, arguments);
}

function getFeatureFlags() {
  return _getFeatureFlags.apply(this, arguments);
}

function _getFeatureFlags() {
  _getFeatureFlags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62() {
    var response;
    return _regeneratorRuntime.wrap(function _callee62$(_context62) {
      while (1) {
        switch (_context62.prev = _context62.next) {
          case 0:
            _context62.next = 2;
            return http.get("".concat(ME_ENDPOINT, "/feature-flags"));

          case 2:
            response = _context62.sent;
            return _context62.abrupt("return", response);

          case 4:
          case "end":
            return _context62.stop();
        }
      }
    }, _callee62);
  }));
  return _getFeatureFlags.apply(this, arguments);
}

function getUsersCalendar(_x39) {
  return _getUsersCalendar.apply(this, arguments);
}

function _getUsersCalendar() {
  _getUsersCalendar = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63(_ref37) {
    var userId, academicYearId, response;
    return _regeneratorRuntime.wrap(function _callee63$(_context63) {
      while (1) {
        switch (_context63.prev = _context63.next) {
          case 0:
            userId = _ref37.userId, academicYearId = _ref37.academicYearId;
            _context63.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/").concat(userId, "/academic-years/").concat(academicYearId, "/calendars"));

          case 3:
            response = _context63.sent;
            return _context63.abrupt("return", response);

          case 5:
          case "end":
            return _context63.stop();
        }
      }
    }, _callee63);
  }));
  return _getUsersCalendar.apply(this, arguments);
}

var getSemesterClasses = /*#__PURE__*/function () {
  var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(userId, semesterId) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return http.get("".concat(constants.API_URL, "/users/").concat(userId, "/semesters/").concat(semesterId, "/classes"));

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getSemesterClasses(_x40, _x41) {
    return _ref38.apply(this, arguments);
  };
}();

var getSemesterSchedules = /*#__PURE__*/function () {
  var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(userId, semesterId) {
    var response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return http.get("".concat(constants.API_URL, "/users/").concat(userId, "/semesters/").concat(semesterId, "/class-schedules"));

          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getSemesterSchedules(_x42, _x43) {
    return _ref39.apply(this, arguments);
  };
}();

var deleteUser = /*#__PURE__*/function () {
  var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref40) {
    var userId, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            userId = _ref40.userId;
            _context3.next = 3;
            return http.post("".concat(USERS_ENDPOINT, "/").concat(userId, "/delete"));

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function deleteUser(_x44) {
    return _ref41.apply(this, arguments);
  };
}();

var restoreUser = /*#__PURE__*/function () {
  var _ref43 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref42) {
    var userId, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            userId = _ref42.userId;
            _context4.next = 3;
            return http.post("".concat(USERS_ENDPOINT, "/").concat(userId, "/restore"));

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function restoreUser(_x45) {
    return _ref43.apply(this, arguments);
  };
}();

var listDeletedUsers = /*#__PURE__*/function () {
  var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref44) {
    var params, response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            params = _ref44.params;
            _context5.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/deleted"), {
              params: params
            });

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function listDeletedUsers(_x46) {
    return _ref45.apply(this, arguments);
  };
}();

var getStudentPublishCertificates = /*#__PURE__*/function () {
  var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref46) {
    var userId, response;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            userId = _ref46.userId;
            _context6.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/students/").concat(userId, "/student-certificates"));

          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function getStudentPublishCertificates(_x47) {
    return _ref47.apply(this, arguments);
  };
}();

var getUserInvoices = /*#__PURE__*/function () {
  var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref48) {
    var userId, response;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            userId = _ref48.userId;
            _context7.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/").concat(userId, "/invoices"));

          case 3:
            response = _context7.sent;
            return _context7.abrupt("return", response);

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function getUserInvoices(_x48) {
    return _ref49.apply(this, arguments);
  };
}();

var getStudentAttendance = /*#__PURE__*/function () {
  var _ref51 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref50) {
    var userId, params, response;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            userId = _ref50.userId, params = _ref50.params;
            _context8.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/students/").concat(userId, "/attendance"), {
              params: params
            });

          case 3:
            response = _context8.sent;
            return _context8.abrupt("return", response);

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function getStudentAttendance(_x49) {
    return _ref51.apply(this, arguments);
  };
}();

function getStudentAttendanceRecord(_x50) {
  return _getStudentAttendanceRecord.apply(this, arguments);
}

function _getStudentAttendanceRecord() {
  _getStudentAttendanceRecord = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64(_ref52) {
    var studentId, response;
    return _regeneratorRuntime.wrap(function _callee64$(_context64) {
      while (1) {
        switch (_context64.prev = _context64.next) {
          case 0:
            studentId = _ref52.studentId;
            _context64.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/students/").concat(studentId, "/attendance-records"));

          case 3:
            response = _context64.sent;
            return _context64.abrupt("return", response);

          case 5:
          case "end":
            return _context64.stop();
        }
      }
    }, _callee64);
  }));
  return _getStudentAttendanceRecord.apply(this, arguments);
}

function getUserCreditCards() {
  return _getUserCreditCards.apply(this, arguments);
}

function _getUserCreditCards() {
  _getUserCreditCards = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65() {
    var response;
    return _regeneratorRuntime.wrap(function _callee65$(_context65) {
      while (1) {
        switch (_context65.prev = _context65.next) {
          case 0:
            _context65.next = 2;
            return http.get("".concat(ME_ENDPOINT, "/credit-cards"));

          case 2:
            response = _context65.sent;
            return _context65.abrupt("return", response);

          case 4:
          case "end":
            return _context65.stop();
        }
      }
    }, _callee65);
  }));
  return _getUserCreditCards.apply(this, arguments);
}

function deleteCreditCard(_x51) {
  return _deleteCreditCard.apply(this, arguments);
}

function _deleteCreditCard() {
  _deleteCreditCard = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(_ref53) {
    var creditCardId, response;
    return _regeneratorRuntime.wrap(function _callee66$(_context66) {
      while (1) {
        switch (_context66.prev = _context66.next) {
          case 0:
            creditCardId = _ref53.creditCardId;
            _context66.next = 3;
            return http["delete"]("".concat(ME_ENDPOINT, "/credit-cards/").concat(creditCardId));

          case 3:
            response = _context66.sent;
            return _context66.abrupt("return", response);

          case 5:
          case "end":
            return _context66.stop();
        }
      }
    }, _callee66);
  }));
  return _deleteCreditCard.apply(this, arguments);
}

function getAllStageAttendanceSettings(_x52) {
  return _getAllStageAttendanceSettings.apply(this, arguments);
}

function _getAllStageAttendanceSettings() {
  _getAllStageAttendanceSettings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67(_ref54) {
    var userId, semesterId, response;
    return _regeneratorRuntime.wrap(function _callee67$(_context67) {
      while (1) {
        switch (_context67.prev = _context67.next) {
          case 0:
            userId = _ref54.userId, semesterId = _ref54.semesterId;
            _context67.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/").concat(userId, "/semesters/").concat(semesterId, "/stage-attendance-settings"));

          case 3:
            response = _context67.sent;
            return _context67.abrupt("return", response);

          case 5:
          case "end":
            return _context67.stop();
        }
      }
    }, _callee67);
  }));
  return _getAllStageAttendanceSettings.apply(this, arguments);
}

function getParentChildren(_x53) {
  return _getParentChildren.apply(this, arguments);
}

function _getParentChildren() {
  _getParentChildren = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68(_ref55) {
    var parentId, response;
    return _regeneratorRuntime.wrap(function _callee68$(_context68) {
      while (1) {
        switch (_context68.prev = _context68.next) {
          case 0:
            parentId = _ref55.parentId;
            _context68.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/parents/").concat(parentId, "/children"));

          case 3:
            response = _context68.sent;
            return _context68.abrupt("return", response);

          case 5:
          case "end":
            return _context68.stop();
        }
      }
    }, _callee68);
  }));
  return _getParentChildren.apply(this, arguments);
}

function getUserComplaints(_x54) {
  return _getUserComplaints.apply(this, arguments);
}

function _getUserComplaints() {
  _getUserComplaints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69(_ref56) {
    var userId, params, response;
    return _regeneratorRuntime.wrap(function _callee69$(_context69) {
      while (1) {
        switch (_context69.prev = _context69.next) {
          case 0:
            userId = _ref56.userId, params = _ref56.params;
            _context69.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/").concat(userId, "/complaints"), {
              params: params
            });

          case 3:
            response = _context69.sent;
            return _context69.abrupt("return", response);

          case 5:
          case "end":
            return _context69.stop();
        }
      }
    }, _callee69);
  }));
  return _getUserComplaints.apply(this, arguments);
}

function getUserInfo(_x55) {
  return _getUserInfo.apply(this, arguments);
}

function _getUserInfo() {
  _getUserInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70(_ref57) {
    var params, response;
    return _regeneratorRuntime.wrap(function _callee70$(_context70) {
      while (1) {
        switch (_context70.prev = _context70.next) {
          case 0:
            params = _ref57.params;
            _context70.next = 3;
            return http.get("".concat(USERS_ENDPOINT, "/info"), {
              params: params
            });

          case 3:
            response = _context70.sent;
            return _context70.abrupt("return", response);

          case 5:
          case "end":
            return _context70.stop();
        }
      }
    }, _callee70);
  }));
  return _getUserInfo.apply(this, arguments);
}

var getUserGradebookVisibility = /*#__PURE__*/function () {
  var _ref59 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref58) {
    var userId, response;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            userId = _ref58.userId;
            _context9.next = 3;
            return http.get("".concat(constants.API_URL, "/users/").concat(userId, "/gradebook/visibility"));

          case 3:
            response = _context9.sent;
            return _context9.abrupt("return", response);

          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function getUserGradebookVisibility(_x56) {
    return _ref59.apply(this, arguments);
  };
}();

var changeDismissalState = /*#__PURE__*/function () {
  var _ref61 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref60) {
    var userId, data, response;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            userId = _ref60.userId, data = _ref60.data;
            _context10.next = 3;
            return http.post("".concat(constants.API_URL, "/users/students/").concat(userId, "/dismissal"), data);

          case 3:
            response = _context10.sent;
            return _context10.abrupt("return", response);

          case 5:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function changeDismissalState(_x57) {
    return _ref61.apply(this, arguments);
  };
}();

var getUserCallHistory = /*#__PURE__*/function () {
  var _ref63 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref62) {
    var userId, params, response;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            userId = _ref62.userId, params = _ref62.params;
            _context11.next = 3;
            return http.get("".concat(constants.API_URL, "/users/").concat(userId, "/dismissals/call-history"), {
              params: params
            });

          case 3:
            response = _context11.sent;
            return _context11.abrupt("return", response);

          case 5:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function getUserCallHistory(_x58) {
    return _ref63.apply(this, arguments);
  };
}();

var getChildrenDismissalCalls = /*#__PURE__*/function () {
  var _ref65 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref64) {
    var userId, response;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            userId = _ref64.userId;
            _context12.next = 3;
            return http.get("".concat(constants.API_URL, "/users/parents/").concat(userId, "/dismissal-calls"));

          case 3:
            response = _context12.sent;
            return _context12.abrupt("return", response);

          case 5:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function getChildrenDismissalCalls(_x59) {
    return _ref65.apply(this, arguments);
  };
}();

var callChildrenForDismissal = /*#__PURE__*/function () {
  var _ref67 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref66) {
    var userId, data, response;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            userId = _ref66.userId, data = _ref66.data;
            _context13.next = 3;
            return http.post("".concat(constants.API_URL, "/users/parents/").concat(userId, "/dismissal-call"), data);

          case 3:
            response = _context13.sent;
            return _context13.abrupt("return", response);

          case 5:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function callChildrenForDismissal(_x60) {
    return _ref67.apply(this, arguments);
  };
}();

var getUserDigitalId = /*#__PURE__*/function () {
  var _ref69 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref68) {
    var userId, response;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            userId = _ref68.userId;
            _context14.next = 3;
            return http.get("".concat(constants.API_URL, "/users/").concat(userId, "/digital-identity"));

          case 3:
            response = _context14.sent;
            return _context14.abrupt("return", response);

          case 5:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function getUserDigitalId(_x61) {
    return _ref69.apply(this, arguments);
  };
}();

var listUsersMessages = /*#__PURE__*/function () {
  var _ref71 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref70) {
    var userId, params, response;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            userId = _ref70.userId, params = _ref70.params;
            _context15.next = 3;
            return http.get("".concat(constants.API_URL_V2, "/users/").concat(userId, "/messages"), {
              params: params
            });

          case 3:
            response = _context15.sent;
            return _context15.abrupt("return", response);

          case 5:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));

  return function listUsersMessages(_x62) {
    return _ref71.apply(this, arguments);
  };
}();

var listUserPossibleReceivers = /*#__PURE__*/function () {
  var _ref73 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(_ref72) {
    var params, response;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            params = _ref72.params;
            _context16.next = 3;
            return http.get("".concat(constants.API_URL, "/users/me/possible-receivers"), {
              params: params
            });

          case 3:
            response = _context16.sent;
            return _context16.abrupt("return", response);

          case 5:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));

  return function listUserPossibleReceivers(_x63) {
    return _ref73.apply(this, arguments);
  };
}();

var getUserMessageSettings = /*#__PURE__*/function () {
  var _ref75 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(_ref74) {
    var params, response;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            params = _ref74.params;
            _context17.next = 3;
            return http.get("".concat(ME_ENDPOINT, "/messages/settings"), {
              params: params
            });

          case 3:
            response = _context17.sent;
            return _context17.abrupt("return", response);

          case 5:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));

  return function getUserMessageSettings(_x64) {
    return _ref75.apply(this, arguments);
  };
}();

var getViewAsUsers = /*#__PURE__*/function () {
  var _ref77 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(_ref76) {
    var params, response;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            params = _ref76.params;
            _context18.next = 3;
            return http.get("".concat(ME_ENDPOINT, "/view-as-users"), {
              params: params
            });

          case 3:
            response = _context18.sent;
            return _context18.abrupt("return", response);

          case 5:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));

  return function getViewAsUsers(_x65) {
    return _ref77.apply(this, arguments);
  };
}();

var getViewAsFilters = /*#__PURE__*/function () {
  var _ref79 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(_ref78) {
    var params, response;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            params = _ref78.params;
            _context19.next = 3;
            return http.get("".concat(ME_ENDPOINT, "/view-as-filters"), {
              params: params
            });

          case 3:
            response = _context19.sent;
            return _context19.abrupt("return", response);

          case 5:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));

  return function getViewAsFilters(_x66) {
    return _ref79.apply(this, arguments);
  };
}();

export default _objectSpread(_objectSpread(_objectSpread(_objectSpread({
  registerPushNotificationToken: registerPushNotificationToken,
  unregisterPushNotificationToken: unregisterPushNotificationToken,
  getUserCourseGrades: getUserCourseGrades,
  getUserData: getUserData,
  getUserGradeableItems: getUserGradeableItems,
  getUserAnnouncements: getUserAnnouncements,
  changeUserRole: changeUserRole,
  deactivateUser: deactivateUser,
  activateUser: activateUser,
  updateUser: updateUser,
  updateMe: updateMe,
  getStudentSemesters: getStudentSemesters,
  getTeacherSemesters: getTeacherSemesters,
  getUserMaterials: getUserMaterials,
  getUserCourses: getUserCourses,
  getTeacherCourseTemplates: getTeacherCourseTemplates,
  getTeacherQuestions: getTeacherQuestions,
  updateSubjects: updateSubjects,
  getHodCourseTemplates: getHodCourseTemplates,
  updateCourseTemplates: updateCourseTemplates,
  getHodQuestions: getHodQuestions,
  getPrincipalCourseTemplates: getPrincipalCourseTemplates,
  getPrincipalQuestions: getPrincipalQuestions,
  getPrincipalClasses: getPrincipalClasses,
  updatePrincipal: updatePrincipal,
  updateParent: updateParent,
  getUserActiveSubmission: getUserActiveSubmission,
  getStudentAssessments: getStudentAssessments,
  listNotifications: listNotifications,
  markAllNotificationsAsSeen: markAllNotificationsAsSeen,
  markAllNotificationsAsRead: markAllNotificationsAsRead,
  getUnreadNotificationsCount: getUnreadNotificationsCount,
  getUnseenNotificationsCount: getUnseenNotificationsCount,
  deleteRefreshToken: deleteRefreshToken,
  deactivateBulkUsers: deactivateBulkUsers,
  activateBulkUsers: activateBulkUsers,
  getHodClasses: getHodClasses,
  getTeacherClasses: getTeacherClasses,
  updateStudentPerformanceComment: updateStudentPerformanceComment,
  getStudentAssessmentsV1: getStudentAssessmentsV1,
  getStudentHomework: getStudentHomework,
  getStudentClasswork: getStudentClasswork,
  viewAsUser: viewAsUser,
  getFeatureFlags: getFeatureFlags,
  getUsersCalendar: getUsersCalendar,
  getSemesterClasses: getSemesterClasses,
  getSemesterSchedules: getSemesterSchedules,
  deleteUser: deleteUser,
  restoreUser: restoreUser,
  listDeletedUsers: listDeletedUsers,
  getStudentPublishCertificates: getStudentPublishCertificates,
  getUserInvoices: getUserInvoices
}, linkedAccounts), emailVerification), passwordReset), {}, {
  getStudentAttendance: getStudentAttendance,
  getStudentAttendanceRecord: getStudentAttendanceRecord,
  getUserCreditCards: getUserCreditCards,
  deleteCreditCard: deleteCreditCard,
  getAllStageAttendanceSettings: getAllStageAttendanceSettings,
  getParentChildren: getParentChildren,
  getUserComplaints: getUserComplaints,
  getUserInfo: getUserInfo,
  getUserGradebookVisibility: getUserGradebookVisibility,
  changeDismissalState: changeDismissalState,
  getUserCallHistory: getUserCallHistory,
  getChildrenDismissalCalls: getChildrenDismissalCalls,
  callChildrenForDismissal: callChildrenForDismissal,
  getUserDigitalId: getUserDigitalId,
  listUsersMessages: listUsersMessages,
  listUserPossibleReceivers: listUserPossibleReceivers,
  getUserMessageSettings: getUserMessageSettings,
  getViewAsUsers: getViewAsUsers,
  getViewAsFilters: getViewAsFilters
});